var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChatUpload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 27,
    viewBox: "0 0 33 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.7096 26.0001H4.19395C2.32848 26.0001 0.75 24.3751 0.75 22.4546V9.45463C0.75 7.53417 2.32848 5.90918 4.19395 5.90918H23.7096C25.5751 5.90918 27.1536 7.53417 27.1536 9.45463V22.4546C27.1536 24.3751 25.5751 26.0001 23.7096 26.0001Z",
    stroke: "#656565",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.894531 19.2046L6.92143 13.0001C8.21291 11.6705 10.3654 11.6705 11.8004 13.0001L18.6883 20.091",
    stroke: "#656565",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8203 18.0225L20.1208 14.6248C20.8383 13.8861 21.9862 13.8861 22.7037 14.6248L27.0087 19.0566",
    stroke: "#656565",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8217 11.9658C17.6142 11.9658 18.2567 11.3044 18.2567 10.4885C18.2567 9.67263 17.6142 9.01123 16.8217 9.01123C16.0292 9.01123 15.3867 9.67263 15.3867 10.4885C15.3867 11.3044 16.0292 11.9658 16.8217 11.9658Z",
    fill: "#656565"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.155 11.5227C30.2458 11.5227 32.7514 8.94327 32.7514 5.76136C32.7514 2.57944 30.2458 0 27.155 0C24.0642 0 21.5586 2.57944 21.5586 5.76136C21.5586 8.94327 24.0642 11.5227 27.155 11.5227Z",
    fill: "#656565"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2852 5.76123H30.0251",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1562 8.86373V2.65918",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatUpload);
export default __webpack_public_path__ + "static/media/chat_upload.01c0a727d0420ca00cb08336c2661e43.svg";
export { ForwardRef as ReactComponent };